import { React, useState, useEffect } from "react"
import { Form, Button, Card } from "react-bootstrap"
import axios from "axios"
import { Oval } from "react-loader-spinner"
import { BASE_URL } from "../../utils/constants.js"

import "./Login.scss"

const Login = ({ logUserIn }) => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [showLogin, setShowLogin] = useState(false)
  const [wrongLoginCredentials, setWrongLoginCredentials] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [accountLocked, setAccountLocked] = useState(false)

  useEffect(() => {
    const user = localStorage.getItem("userInfo")
    if(user) {
      logUserIn(JSON.parse(user))
    }
    else(
      setShowLogin(true)
    )
  }, []);


  const submitHandler = async event => {
    event.preventDefault()
    if(username === "" || password === "") {
      setError(true)
      return
    }
    setError(false)
    try {
      const response = await axios.post(`${BASE_URL}/api/v1/user/auth`, {
        username: username,
        password: password,
      }, {
        headers: {"Content-Type": "application/json"},
        withCredentials: true // Send cookies with request
      })
      if(response.data.success) {
        // Store user info (without token) in localStorage
        localStorage.setItem('userInfo', JSON.stringify(response.data.user))
        logUserIn(response.data.user)
      }
    }
    catch(error) {
      console.log(error)
      if(error.response && error.response.status === 403 && error.response.data.locked) {
        // Account is locked
        setAccountLocked(true)
        setErrorMessage(error.response.data.message)
        setWrongLoginCredentials(false)
      } else if(error.response && error.response.status === 401) {
        setWrongLoginCredentials(true)
        setAccountLocked(false)
        // Show custom message if available (e.g., attempts remaining)
        if(error.response.data.message) {
          setErrorMessage(error.response.data.message)
        }
      } else if(error.response && error.response.status === 429) {
        // Rate limit error
        setWrongLoginCredentials(true)
        setAccountLocked(false)
        setErrorMessage("Te veel inlogpogingen. Probeer het later opnieuw.")
      }
      // switch to error screen
    }
  }

  return (
    <div className="login">

      {showLogin? (<Form noValidate onSubmit={submitHandler}>
      <Card>
        <Card.Body>
        <h1 className="logo">OTOS</h1>
        <p className="subtitle">Login to your account</p>      
        {/* {error && <Message variant="danger">{error}</Message>} */}
        {/* {loading && <Loader />} */}
          <Form.Group className="form-group">
            {/* <Form.Label>username Address</Form.Label> */}
            <Form.Control
              style={{ border: (error && username === "") || wrongLoginCredentials ? "2px solid red" : "" }}
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => {
                setWrongLoginCredentials(false)
                setAccountLocked(false)
                setErrorMessage("")
                setUsername(e.target.value)
              }}
            ></Form.Control>
            {error && username === ""? <div className="text-danger"><small>Please provide your username</small></div> : null}
          </Form.Group>

          <Form.Group className="form-group">
            {/* <Form.Label>Password</Form.Label> */}
            <Form.Control
              style={{ border: (error && password === "") || wrongLoginCredentials ? "2px solid red" : "" }}
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setWrongLoginCredentials(false)
                setAccountLocked(false)
                setErrorMessage("")
                setPassword(e.target.value)
              }}
            ></Form.Control>
            {error && password === ""? <div className="text-danger"><small>Please provide your password</small></div> : null}
          </Form.Group>

          {(wrongLoginCredentials || accountLocked) && errorMessage && (
            <div className={`login-alert ${accountLocked ? 'locked' : 'error'}`}>
              {errorMessage}
            </div>
          )}

          <Button type="submit" variant="primary">
            Login
          </Button>
          </Card.Body>
          
          </Card>
        </Form>) : (
        <div className="loading-container">
          <Oval
            height={80}
            width={80}
            color="#ffffff"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="rgba(255, 255, 255, 0.5)"
            strokeWidth={3}
            strokeWidthSecondary={3}
          />
        </div>
        )}
    </div>
  );
}

export default Login